<template>
    <div>
        <el-form :inline="true" :model="searchForm" class="forTbFilter">
            <el-form-item label="是否分销："> 
                <el-select v-model="searchForm.isSold" clearable>
                    <el-option label="否" value="0"></el-option>
                    <el-option label="是" value="1"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="卡状态："> 
                <el-select v-model="searchForm.cardState" clearable>
                    <el-option v-for="item in cardStateOption" :value="item.code" :key="item.id + item.description" :label="item.description"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="运营商名称："> 
                <el-select v-model="searchForm.supplierTypeCode" clearable filterable>
                    <el-option v-for="item in supplierOption" :value="item.code" :key="item.description" :label="item.description"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="通道：">
                <el-input v-model.trim="searchForm.alias" @keyup.enter.native="getAgentCardListHandle" clearable></el-input>
            </el-form-item>
            <el-form-item label="套餐组名称："> 
                <el-select v-model="searchForm.basePkgGroup" clearable filterable>
                    <el-option v-for="item in agentPkgGroup" :key="item.id" :value="item.id" :label="item.name"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="分销商：">
                <el-input v-model.trim="searchForm.agentName" @keyup.enter.native="getAgentCardListHandle" clearable></el-input>
            </el-form-item>
            <el-form-item label="卡板号：">
                <el-input v-model.trim="searchForm.iccid" @keyup.enter.native="getAgentCardListHandle" clearable></el-input>
            </el-form-item>
            <el-form-item label="接入号：">
                <el-input v-model.trim="searchForm.intoNo" @keyup.enter.native="getAgentCardListHandle" clearable></el-input>
            </el-form-item>
             <el-form-item label="虚拟号：">
                <el-input v-model.trim="searchForm.virtualNo" @keyup.enter.native="getAgentCardListHandle" clearable></el-input>
            </el-form-item>
            <el-form-item label="卡号段：" class="ICCIDRange">
                <el-col :span="11">
                    <el-input v-model.trim="searchForm.iccidStart"  placeholder="支持虚拟号段" clearable></el-input>
                </el-col>
                <el-col :span="2" class="separate">-</el-col>
                <el-col :span="11">
                    <el-input v-model.trim="searchForm.iccidEnd" placeholder="搜索-分销-回收功能" clearable></el-input>
                </el-col>                
            </el-form-item>
             <el-form-item label="卡备注：">
                <el-input v-model.trim="searchForm.remark" @keyup.enter.native="getAgentCardListHandle" clearable></el-input>
            </el-form-item>
              <el-form-item label="激活时间：" class="dateRange">
                <el-date-picker v-model="searchForm.time" range-separator="至" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
             <el-form-item label="到期时间：" class="dateRange">
                <el-date-picker v-model="searchForm.timePkg" range-separator="至" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
             <br/>
            <el-form-item label="批量搜索：" class="iccid_textarea_range">
                <el-input
                    type="textarea"
                    :rows="2"
                    placeholder="请输入1个或多个ICCID号,多个请用逗号、空格、或者换行分隔"
                    v-model="searchForm.iccidStrs">
                    </el-input>
            </el-form-item>
                  <br/>


            <el-form-item class="btnArea">
                <el-button type="primary" @click="getAgentCardListHandle"  plain icon="el-icon-search">查询</el-button>
                <el-button type="success" @click="exportSimInfoHandle" plain icon="el-icon-download">导出Excel</el-button>
                <el-button type="success" @click="showSimHandle" plain >卡板分销</el-button>
                <el-button type="warning" @click="simRecoverybutHandler" icon="el-icon-s-ticket" plain>卡板回收</el-button>
                <el-button type="primary" @click="updateRemark" icon="el-icon-s-ticket" plain>批量备注</el-button>


                 <el-button type="success" @click="batchInvent" icon="el-icon-s-ticket" plain>批量充值</el-button>
            </el-form-item> 
        </el-form>
        <el-table :data="tbpg.tableData" border fit highlight-current-row style="width: 100%;" :header-cell-style="{background:'#f5f5f5'}" @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="55"/>
            <el-table-column label="ICCID号" align="center">
                <template slot-scope="scope">
                    <a href="javascript:void(0);" @click="goToInfoPage(scope.row)">{{ scope.row.iccid }}</a>
                </template> 
            </el-table-column>
            <!-- <el-table-column prop="intoNo" label="MSISDN" align="center"></el-table-column> -->
             <el-table-column prop="virtualNo" label="虚拟号" align="center"></el-table-column>
            <el-table-column prop="alias" label="运营商" align="center"></el-table-column>
             <el-table-column  align="center"  label="实名状态">
                 <template v-slot="scope">
                    <el-tooltip v-if="scope.row.authName=='已实名'" :content="scope.row.authName">
                        <p style="color:green"> {{scope.row.authName}}</p>
                    </el-tooltip>
                    <el-tooltip v-else  :content="scope.row.authName">
                        <p style="color:crimson"> {{scope.row.authName}}</p>
                    </el-tooltip> 
                </template>
            </el-table-column>
            <el-table-column prop="basePkgGroupName" label="套餐组" align="center"></el-table-column>
            <el-table-column label="总流量(G)" align="center">
                <template slot-scope="scope">
                    {{ fluxMtoG(scope.row.flowRate) }}
                </template>
            </el-table-column>
            <el-table-column label="已使用流量(G)" align="center">
                <template slot-scope="scope">
                    {{ fluxMtoG(scope.row.usedFlowRate) }}
                </template>
            </el-table-column>
             <el-table-column label="已使用流量(M)" align="center">
                <template slot-scope="scope">
                    {{ scope.row.usedFlowRate }}
                </template>
            </el-table-column>
            <el-table-column label="剩余流量(G)" align="center">
                <template slot-scope="scope">
                    {{ decrease(fluxMtoG(scope.row.flowRate), fluxMtoG(scope.row.usedFlowRate)) }}
                </template>
            </el-table-column>
            <!-- <el-table-column prop="cardTypeName" label="卡片类型" width="100"></el-table-column> -->
            <el-table-column prop="agentPathNames" label="分销商姓名" align="center"></el-table-column>
             <el-table-column  align="center"  label="卡状态"  width="100px">
                 <template v-slot="scope">
                    <el-tooltip v-if="scope.row.cardState==2"  :content="scope.row.cardStateName">
                        <p style="color:green"> {{scope.row.cardStateName}}</p>
                    </el-tooltip>
                     <el-tooltip v-else-if="scope.row.cardState==1||scope.row.cardState==0"  :content="scope.row.cardStateName" >
                        <p style="color:brown"> {{scope.row.cardStateName}}</p>
                    </el-tooltip>
                    <el-tooltip v-else  :content="scope.row.cardStateName">
                        <p style="color:crimson"> {{scope.row.cardStateName}}</p>
                    </el-tooltip> 
                </template>
            </el-table-column>
            <el-table-column prop="isSoldName" label="分销状态" align="center"></el-table-column>

              <el-table-column  align="center"  label="卡备注"  width="100px">
                 <template v-slot="scope">
                    <el-tooltip   :content="scope.row.remark">
                        <p style="color:crimson"> {{scope.row.remark}}</p>
                    </el-tooltip> 
                </template>
            </el-table-column>
        </el-table>  
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500]"
            :page-size="tbpg.pageSize"
			background
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination>  
        <el-dialog :append-to-body="true"  title="卡片分销" :visible.sync="simHandleVisibale" width="600px" @close="cancel" :close-on-click-modal="false">
            <el-form ref="simHandleForm" :model="simHandleForm" :rules="simHandleRules" label-width="120px">
                <el-form-item label="代理商：" prop="agentId">
                    <el-select v-model="simHandleForm.agentId" filterable>
                        <el-option v-for="item in agentListOption" :value="item.id" :key="item.id" :label="item.name"></el-option>
                    </el-select>  
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="simDistributHandler">确 定</el-button>
            </div>             
        </el-dialog>



         <el-dialog :append-to-body="true"  title="批量备注" :visible.sync="updateFlg" width="600px" @close="cancel" :close-on-click-modal="false">
            <el-form ref="updateInfo" :model="updateInfo"   label-width="120px">
               <el-form-item label="备注：" prop="remark">
                        <el-input v-model.trim="updateInfo.remark" clearable></el-input>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="sureUpdateRemark">确 定</el-button>
            </div>             
        </el-dialog>



      <!-- SIM批量充值 -->
        <el-dialog :append-to-body="true"  title="批量充值" :visible.sync="simBatchRechangeVisibale" width="600px" :close-on-click-modal="false">
            <el-form ref="rechargeForm" :model="rechargeForm" :rules="rechargeFormRules" label-width="130px">
                 <el-form-item label="充值数量：" prop="countSize">
                    <el-input v-model="rechargeForm.countSize" disabled  clearable></el-input>
                </el-form-item>

                <el-form-item label="套餐组：" prop="typeGroupId">
                    <el-select v-model="rechargeForm.typeGroupId" @change="changeHandler" filterable>
                        <el-option v-for="item in agentPkgGroup" :key="item.id" :value="item.id" :label="item.name"></el-option>
                    </el-select> 
                </el-form-item>
                 <el-form-item label="套餐名称：" prop="packageId">
                    <el-select v-model="rechargeForm.packageId" clearable>
                        <el-option v-for="item in pkgList" :value="item.id" :key="item.id" :label="item.packageName"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="生效时间：" prop="isNextMonth">
                    <el-select v-model="rechargeForm.isNextMonth" clearable>
                        <el-option value="0" label="本月生效"></el-option>
                        <el-option value="1" label="次月生效"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="备注" prop="remark">
                    <el-input v-model="rechargeForm.remark" clearable></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="sureBatchRechangeHandler">确 定</el-button>
            </div> 
        </el-dialog>    


    </div>
</template>

<script>
import {getAgentCardList, simDistribut, getCardStateDict, simRecovery ,exportSimInfo,getPkgListOfGroup} from '@/api/sim.js'
import common from '@/utils/common.js'
export default {
    data(){
        return {
            searchForm: {
                remark:'',
                iccidStrs:'',
                isSold: '',
                cardState: '',
                supplierCode: '',
                alias: '',
                basePkgGroup: '',
                agentName: '',
                iccid: '',
                intoNo: '',
                iccidStart: '',
                iccidEnd: '',
                virtualNo:''
            },
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0,
            },            
            simHandleVisibale: false,
            simHandleForm: {
                agentId: ''
            },
            agentPkgGroup: [],
            supplierOption: [],
            agentListOption: [],
            cardStateOption: [],

            simHandleRules: {
                agentId: [{required: true, message: '请选择代理商', trigger: 'change'}]
            } ,
            updateFlg:false,
            updateInfo:{
                remark:'',
                iccidStrs:'',
            },

            //批量充值 
            simBatchRechangeVisibale: false,  
            rechargeForm: {
                iccidStrs: '', // 看看是拼接字符串中间用 ， 隔开。  还是用数组传递
                countSize:'0', //充值数量 展示给用户看
                typeGroupId: '',
                packageId: '',
                isNextMonth: '0',
                isPay:0,
                agentId:'',
                remark: ''
            },
            pkgList:[],
            rechargeFormRules:{
                typeGroupId: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                packageId: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                isNextMonth: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                isPay: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
            },
            multipleSelection:[]
        }
    },
    methods: {
       handleSelectionChange(data){
            this.multipleSelection = data;
        },
        batchInvent(){
            if(this.multipleSelection.length === 0){
                this.$message.error('请勾选你要充值的卡号！')
                return;
            }
            this.rechargeForm.countSize = this.multipleSelection.length
            this.rechargeForm.iccidStrs = this.multipleSelection.map(item=>{
                return item.iccid
            }).join('-')
            this.simBatchRechangeVisibale=true;
            common.getAgentListOptionCom(this, 'agentListOption');
        },
        //获取pkgList
        changeHandler(){
            this.rechargeForm.packageId = '';
            var data = {
                groupId: this.rechargeForm.typeGroupId
            }
             getPkgListOfGroup(data).then(res => {
                if(res.data.code == 200){
                    this.pkgList = res.data.data;
                }else{
                    this.$message.error(res.data.message);
                }
            })             
        },
        //确定SIM批量充值
        sureBatchRechangeHandler(){
            const formData = new FormData();
            Object.keys(this.rechargeForm).forEach((key) => {
                formData.append(key, this.rechargeForm[key]);
            });
            common.sysRequest('sim/invest/batch/select/invent', formData, 'post').then(res => {
                if(res.data.code == 200){
                    this.simBatchRechangeVisibale=false;
                    this.$message.success('充值成功！');
                    this.getAgentCardListHandle();
                }else {
                    this.$message.error(res.data.message);
                }
            })
        },















        sureUpdateRemark(){
             common.sysRequest("sim/agent/update/remark", this.updateInfo, 'post').then(res => {
                 if(res.data.code == 200){
                    this.getAgentCardListHandle();
                    this.$message.success(res.data.message);
                    this.updateFlg = false;    
                 }else{
                    this.$message.error(res.data.message);
                 }

            })    
        },
        updateRemark(){
            if(!this.searchForm.iccidStrs){
                 this.$message.error('请输入 批量搜索 卡号。 进行批量变更备注！');
                 return;
            }
            this.updateInfo.iccidStrs=this.searchForm.iccidStrs;
            this.updateFlg=true;
        },

        cancel(){
            this.simBatchRechangeVisibale=false;
            this.simHandleVisibale = false;   
            this.updateFlg = false;    
            this.$refs.simHandleForm.resetFields();  
        },
        getAgentCardListHandle($event){
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);          
            getAgentCardList(data).then(res => {
                common.listCallback(this, res, 'tbpg');
            })
        },
        goToInfoPage(row){
            this.$store.commit('menu/setFromPage', 'cardList');
            this.$store.commit('menu/setFromPageIccid', row.iccid);
            document.getElementById('cardInfoMenu').click();
        },
        showSimHandle(title){
            var iccidStart = this.searchForm.iccidStart;
            var iccidEnd = this.searchForm.iccidEnd;
            if(iccidStart == "" || iccidEnd == ""){
                this.$message.error('请输入要分销的ICCID号段');
                return false;
            }else{
                this.simHandleVisibale = true;
                common.getAgentListOptionCom(this, 'agentListOption');
            }            
        },        
        exportSimInfoHandle(){//导出excel文件
            this.$confirm("您确定要导出SIM卡列表吗？", "提示" ,{          
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                  var data = common.getRequestParams(this, 'tbpg', this.searchForm);
                exportSimInfo(data).then(res =>{
                    if(res.data.code == 200){
                        this.$message.success('数据导出中,请稍候去任务中心下载');
                    }else{
                        this.$message.error(res.data.msg);
                    }
                }).catch(err=>console.error(err));
            })
        },
        simDistributHandler(){
            this.$refs.simHandleForm.validate(valid => {
                if(valid){            
                    var data = {
                        iccidStart: this.searchForm.iccidStart,
                        iccidEnd: this.searchForm.iccidEnd,
                        agentId: this.simHandleForm.agentId
                    }
                    simDistribut(data).then(res => {
                        if(res.data.code == 200){
                            this.$message.success('分销完成');
                            this.simHandleVisibale = false;
                            this.getAgentCardListHandle();
                        }else{
                            this.$message.error(res.data.message);
                        }
                    })
                }
            })
        },
        simRecoverybutHandler(){
            var iccidStart = this.searchForm.iccidStart;
            var iccidEnd = this.searchForm.iccidEnd;
            if(iccidStart == "" || iccidEnd == ""){
                this.$message.error('请输入要回收的ICCID号段');
                return false;
            }
            this.$confirm('确定回收这批卡片吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                var data = {
                    iccidStart,
                    iccidEnd
                }
                simRecovery(data).then(res => {
                    if(res.data.code == 200){
                        this.$message.success(res.data.message);
                        this.getAgentCardListHandle();
                    }else{
                        this.$message.error(res.data.message);
                    }
                })
            }).catch(()=>{})
        }, 
  
        handleSizeChange(val){
            this.tbpg.pageSize = val;
            this.getAgentCardListHandle();
        },
        handleCurrentChange(val){
            this.tbpg.currentPage = val;
            this.getAgentCardListHandle();
        }  
    },
    created () {
        
        common.getAgentPkgGroupListCom(this, 'agentPkgGroup');
        common.getSupplierOptionCom(this, 'supplierOption');
        getCardStateDict({}).then(res => {
            if(res.data.code == 200){
                this.cardStateOption = res.data.data;
            }else{
                this.$message.error(res.data.message);
            }    
        })

        this.getAgentCardListHandle();
    }
}
</script>

<style lang="less" scoped>

</style>

